// wechatAuth.js
import config from '@/api/base'
import Vue from 'vue'
let browser = navigator.userAgent.toLowerCase();
let flag = {};
if (browser.match(/Alipay/i) == "alipay") {
    flag.id = "12";
    flag.name = 'ali'
} else if (browser.match(/MicroMessenger/i) == "micromessenger") {
    flag.id = "13";
    flag.name = "wx"

}

// wechatAuth.js
// const browser = Vue.prototype.checkBrowser;
export function redirectToWeChatAuth(redirectPath) {
    // redirectPath = flag.id==13?redirectPath:"/weChat/auth";
    console.log(flag,'846849')
    // const appId = "wxfd5a332c1d9dbe1f";
    const appId = flag.id==13?"wxfd5a332c1d9dbe1f":"2021001144603212";
    // 检测URL的协议是https还是http
    let protocol = config.url.substr (0,5);
    // 根据协议选择不同的redirectUri
    let redirectUri = protocol === "https" ? config.https+redirectPath:config.http+redirectPath;
    console.log(protocol,redirectUri,'redirectUri');
    // const baseUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?";
    const baseUrl =  flag.id==13?"https://open.weixin.qq.com/connect/oauth2/authorize?":"https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?";
    if (flag.id==13) {
        const weChatParams = new URLSearchParams({
            appid: appId,
            redirect_uri: redirectUri,
            response_type: "code",
            scope: "snsapi_base",
            state: "1" // 可以根据实际情况修改或生成state参数
        });
        const authUrl = baseUrl + weChatParams.toString() + "#wechat_redirect";
        window.location.href = authUrl;
    }else{
        const weChatParams = new URLSearchParams({
            app_id: appId,
            redirect_uri: redirectUri,
            scope: "auth_base",
            state: "init" // 可以根据实际情况修改或生成state参数
        });

        const authUrl = baseUrl + weChatParams.toString();

        window.location.href = authUrl;
    }
  

}

export default redirectToWeChatAuth;




